/**
 * @file Browser detection component.
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { detect } from 'detect-browser';

class BrowserDetect extends Component {
  static propTypes = {
    browsers: PropTypes.arrayOf(
      PropTypes.oneOf([
        'edge',
        'ie',
        'chrome',
        'firefox',
        'opera',
        'ios',
        'android',
        'safari',
        'samsung',
        'ios-webview',
      ]),
    ),
    os: PropTypes.arrayOf(
      PropTypes.oneOf([
        'Windows 10',
        'Windows 7',
        'Windows 8',
        'Windows 8.1',
        'Windows Vista',
        'Open BSD',
        'Linux',
        'Mac OS',
        'Windows Mobile',
        'Android OS',
        'iOS',
      ]),
    ),
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.string,
    ]),
  };

  static defaultProps = {
    browsers: [],
    os: [],
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    this.setState(() => ({
      isMounted: true,
    }));
  }

  render() {
    const { isMounted } = this.state;
    const { browsers, os, children } = this.props;
    const browser = detect();

    if (
      !isMounted ||
      !browser ||
      (browsers.length && !browsers.includes(browser.name)) ||
      (os.length && !os.includes(browser.os))
    ) {
      return null;
    }

    return children;
  }
}

export default BrowserDetect;
